define((require) => {
    "use strict";

    const IntegrationModel = require("ui/settings/integrations/IntegrationModel");

    /**
     * Marker class for Thumbnails generated third party image service.
     *
     * @class ThumbnailsImageDashboardIntegration
     */
    return IntegrationModel.extend("ThumbnailsImageDashboardIntegration", {}, {
        type: "ThumbnailsImageDashboardIntegration"
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/settings/integrations/ThumbnailsImageDashboardIntegrationModel.js